<template>
    <div id="footer">
        <div class="title">联系我们</div>
        <el-row>
            <el-col :span="6">
                <ul class="foot_list">
                    <li><span>产品介绍</span></li>
                    <li><span>商业合作</span></li>
                    <li><span>技术支持</span></li>
                    <li><span>常见问题</span></li>
                </ul>
            </el-col>
            <el-col :span="12">
                <ul class="foot_list2">
                    <div class="foot_first">
                        <div><span>联系方式</span></div>
                    </div>
                    <li>
                        <img src="@/assets/img/lxicon1.png" alt="电话" class="icon">
                        <span>电话:</span> <span>13362850188</span>
                    </li>

                    <li>
                        <img src="@/assets/img/lxicon3.png" alt="邮箱" class="icon">
                        <span>邮箱:</span> <span>522417107@qq.com</span>
                    </li>
                    <li>
                        <img src="@/assets/img/lxicon4.png" alt="地址" class="icon">
                        <span>地址:</span> <span>浙江省宁波市江南路1689号</span>
                    </li>
                </ul>
            </el-col>
            <el-col :span="6">
                <div class="col-sm-4 three">
                    <div class="foot_first"><span>关注</span></div>
                    <div class="right-footer">
                        <div class="inner-right">
                            <img src="@/assets/img/lxicon5.png" alt="" class="left">
                            <img src="@/assets/img/lxicon6.png" alt="" class="left">
                            <img src="@/assets/img/lxicon7.png" alt="" class="left">
                        </div>
                        <div style="padding:0"><img id="erweima" src="@/assets/img/lxerweima8.png" alt=""></div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div>
            <div class="title">合作企业</div>
            <marquee id='marquee' behavior="alternate" contenteditable="true"
                     onstart="this.firstChild.innerHTML+=this.firstChild.innerHTML;" scrollamount="3"
                     onmouseover="this.stop();" onmouseout="this.start();">
                <img src="../assets/img/lg1.png" alt="..." class="">
                <img src="../assets/img/lg2.png" alt="..." class="tow">
                <img src="../assets/img/lg3.png" alt="..." class="">
                <img src="../assets/img/lg4.png" alt="..." class="">
                <img src="../assets/img/lg5.jpg" alt="..." class="">
                <img src="../assets/img/lg6.png" alt="..." class="">
            </marquee>
        </div>
        <div class="title">友情链接</div>
        <el-row :gutter="10">
            <el-col :xs="12" :sm="12" :md="8" :lg="6" v-for="(item,index) in linkList" :key="index">
                <a class="link" :href=item.url >{{item.name}}</a>
            </el-col>
        </el-row>
        <div class="foot_foot">©joyingtec.com <a class="link" href="https://beian.miit.gov.cn/#/Integrated/index"
                                                 target="_blank">浙ICP备20025498号</a>
        </div>
    </div>

</template>

<script>
  export default {
    data() {
      return {
        linkList: [
          {name: '浙江省智能制造专委会', url: 'http://www.zjznzz.cn/'},
          {name: '浙江省经信厅', url: 'http://jxt.zj.gov.cn/'},
          {name: '宁波市经信局', url: 'http://jxj.ningbo.gov.cn/'},
          {name: '宁波工业互联网研究院', url: 'http://www.niii.com/'},
          {name: '中国工信部', url: 'http://www.miit.gov.cn/'},
          {name: '阿里云物联网平台', url: 'https://www.alibabacloud.com/zh/product/iot'},
          {name: 'Fluentd数据采集', url: 'https://www.fluentd.org/'},
          {name: 'Apache Flume数据采集系统', url: 'https://flume.apache.org/'},
        ]
      }
    }
  }
</script>

<style scoped lang="less">
    /* 屏幕小于1440px */
    @media screen and (max-width: 992px) {
        #footer {
            bottom: 0;
            background-color: #4c4c4c;
            padding: 20px 60px 0 60px;
        }

    }

    /* 屏幕大于992px */
    @media screen and (min-width: 992px) {
        #footer {
            bottom: 0;
            background-color: #4c4c4c;
            padding: 20px 160px 0 160px;
        }
    }

    .title {
        color: #ffffff;
        font-size: 24px;
        padding-left: 5px;
        margin-top: 20px;
        margin-bottom: 15px;
        border-left: 4px solid #e5d276;
    }

    .foot_list {
        margin: 0;
        padding: 0;
        float: left;
        font-size: 18px;
        color: #eeeeef;
        list-style-type: none;

        > li {
            list-sytle: none;
            margin-bottom: 10px;
        }
    }

    .foot_first {
        color: #eeeeef;
        font-size: 18px;
        margin-bottom: 10px;
    }

    .foot_list2 {
        margin: 0;
        padding: 0;
        color: #eeeeef;
        list-style-type: none;

        > li {
            font-size: 18px;
            margin-bottom: 10px;

            > img {
                padding-right: 5px;
                weight: 22.5px;
                height: 20px;
            }
        }
    }


    #marquee {
        > img {
            margin-top: 10px;
            height: 60px;
            margin-left: 2em;
        }
    }

    .right-footer {
        display: flex;

        .inner-right {
            display: flex;
            flex-direction: column;
            margin-right: 20px;
        }

        .left {
            width: 28px;
            height: 25px;
            margin-bottom: 10px;
        }
    }
    #erweima {
        height: 96px;
        width: 96px;
    }
    .link {
        font-size: 18px;
        text-decoration: none;
        color: #eeeeef;
    }

    .foot_foot {
        color: #ffffff;
        text-align: center;
        padding: 20px;


    }
</style>
